module.exports = __webpack_public_path__ + "assets/img/vue-website-icon.8532cf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/previews/vue-website-icon.png
// module id = 51
// module chunks = 0